import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Column } from "react-table";
import EpaCard from "../../../../leap-components/EpaCard";
import BreadCrumbs from "./BreadCrumbs";
import Header from "./Header";
import { Grid } from "../../../../leap-components/Grid";
import EtsHomeContainer from "./EtsContainer";

import { GetEtsFetchUrl } from "../../../../api/Ets/IEts";
import { GetDocsUrl } from "../../../../api/Config";

import { EpaGridOrderByFetchParams } from "../../../../leap-components/Grid/EpaGridProps";

interface ISearchResultRow {
  permit_id: string;
  operator_name: string;
  installation_name: string;
  reg_number: string;
  document_link: string;
}

const EtsList = () => {
  const [searchValue, setSearchValue] = useState("");

  const searchChangedFn = (newSearch: string) => {
    setSearchValue(newSearch);
  };

  const tableColumnsBig: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Operator Name",
      accessor: "operator_name",
      Filter: false,
    },
    {
      Header: "Installation Name",
      accessor: "installation_name",
      Filter: false,
    },
    {
      Header: "Reg. No",
      accessor: "reg_number",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        if (rowData.document_link == null) return rowInfo.value;
        return <a href={GetDocsUrl(rowData.document_link)}>{rowInfo.value}</a>;
      },
    },
  ];

  const tableColumnsSmall: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Operator Name",
      accessor: "operator_name",
      Filter: false,
    },
    {
      Header: "Installation Name",
      accessor: "installation_name",
      Filter: false,
    },
    {
      Header: "Reg. No",
      accessor: "reg_number",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <a href={GetDocsUrl(rowData.document_link)}>{rowInfo.value}</a>;
      },
    },
  ];

  const getFetchUrlFactory = () => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any,
      orderBy?: EpaGridOrderByFetchParams
    ) => {
      return GetEtsFetchUrl(pageNo, recordsPerPage, filters);
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory();

  const results = (
    <div>
      <div>
        For permits issued prior to 1 November 2021 please follow{" "}
        <a href="https://www.epa.ie/our-services/licensing/climate-change/eu-emissions-trading-system-/emissions-trading-system---stationary-installations/access-to-current-permits-/">
          link here.
        </a>
        <p>
          Current list of Permitted Installations under the European Communities
          (Greenhouse Gas) Regulations (SI 470 of 2024 and amendments).
        </p>
      </div>
      <div>
        <div className="d-md-none">
          <Grid
            columns={tableColumnsSmall}
            data={[]}
            fetchUrlFunction={fetchUrl}
            enablePagination={false}
            enableQuickFind={false}
          />
        </div>
        <div className="d-none d-md-block">
          <Grid
            columns={tableColumnsBig}
            data={[]}
            fetchUrlFunction={fetchUrl}
            enablePagination={false}
            enableQuickFind={false}
          />
        </div>
      </div>
    </div>
  );

  const contentElement = (
    <div>
      <Row>
        <Col className="ps-0">
          <EpaCard title="Access to Current Permits" content={results} />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs />
      <div className="ps-0">
        <Header />
        <EtsHomeContainer content={contentElement} />
      </div>
    </div>
  );
};

export default EtsList;
